export const initialCfrOptions = {
  background: true,
  border: true,
  entries: 5,
  font: 2,
  bright: 80,
  routeWidth: 40,
};
